<template>
    <div class="rule-choose-box">

        <div class="chosen-rule">
            <el-tag v-for="rule in chosenRules" v-bind:key="rule.code" class="rule-tag" size="small" @close="handleRemoveChosenRule(rule)" closable>{{rule.name}}</el-tag>
        </div>

        <div class="rule-choose-comp">

            <div class="module-tree">
                <module-tree v-model="moduleCode"></module-tree>
            </div>


            <div class="rule-table">
                <rule-table :moduleCode="moduleCode" :chosenRules="chosenRules"
                            @handleRuleChange="handleRuleChange"></rule-table>
            </div>

        </div>

        <input  type="text" :value="value" style='display:none;'>

    </div>
</template>

<script>
    import ModuleTree from "../ModuleTree";
    import RuleTable from "./RuleTable";

    export default {
        name: "RuleChooseBox",
        components: {RuleTable, ModuleTree},
        props:{
            value: {
                type: Array,
                default:function () {
                    return [] ;
                }
            },
            initRuleCodes:{
                type: Array,
                default:function () {
                    return [] ;
                }
            },
        },
        watch: {
            initRuleCodes:{
                deep:true,
                handler:function (v) {

                    let vm = this;
                    if(v.length){
                        vm.$http.post(vm.$api.rule.list,{codes:v,onPage:false}).then((resp)=>{
                            vm.chosenRules =  resp.data.data.rules;
                        });
                    }

                }
            },
            chosenRules:{
               deep:true,
               handler:function () {
                    let ruleCodes = [];
                    this.chosenRules.forEach((rule)=>{
                        ruleCodes.push(rule.code);
                    });
                    this.$emit('input',ruleCodes);
               }
            },
            moduleCode(v) {
                console.log(v);
            }
        },
        data() {
            return {
                moduleCode: '',
                chosenRules: []
            }
        },
        methods: {

            handleRemoveChosenRule(rule){
                this.chosenRules.splice(this.chosenRules.indexOf(rule), 1);
            },

            handleRuleChange(rule) {

                let srcRule = this.chosenRules.find((r) => {
                    if(!r){
                        return false ;
                    }
                    return rule.code === r.code
                });

                if (rule.chosen) {

                    if (!srcRule) {
                        this.chosenRules.push(rule);
                    }

                } else {

                    if (srcRule) {
                        this.chosenRules.splice(this.chosenRules.indexOf(srcRule), 1);
                    }


                }

            }
        },
        mounted() {

            let vm = this;

        }

    }
</script>

<style lang="scss" scoped>

    .rule-choose-box {
        min-height: 500px;
        overflow: hidden;
        border: 1px solid #DCDFE6;
    }

    .chosen-rule {
        border-bottom: 1px solid #dcdfe6;
        min-height: 100px;
    }

    .rule-choose-comp {
        overflow: hidden;
    }

    .module-tree, .rule-table {
        display: inline-block;
        float: left;
    }

    .module-tree {
        width: 179px;
        border-right: 1px solid #dcdfe6;
        min-height: 500px;
        padding: 10px;
    }

    .rule-table {
        width: calc(100% - 220px);
        padding: 10px;
    }

    .chosen-rule {
        padding: 10px;
    }

    .rule-tag {
        margin-right: 10px;
    }

</style>